import React from "react"
import AvenueImg from "UI/AvenueImg"

import { Icon } from "UI"
import {
  Container,
  Featured,
  FeaturedPhoto,
  TextBlock,
  CustomTestimonialText,
} from "./styled"

const CustomTestimonial = ({ author, image, testimonial }) => {
  return (
    <Container>
      <Featured>
        <Icon name="ll-arrow" color="#47C5F3" width={[66, null, 90, 115]} />
        <Icon name="ll-arrow" color="#1870B0" width={[22, null, 30, 39]} />
        {image && (
          <FeaturedPhoto>
            <AvenueImg
              fluid={{ sourceUrl: image?.url, aspectRatio: 1.19 }}
              alt=""
            />
          </FeaturedPhoto>
        )}
      </Featured>
      <TextBlock>
        <Icon name="quotation-marks" width={[45, 40, 50, 68]} color="#47C5F3" />

        <div>
          <CustomTestimonialText as="h5">{testimonial}</CustomTestimonialText>

          {author && <span dangerouslySetInnerHTML={{ __html: author }} />}
        </div>
      </TextBlock>
    </Container>
  )
}

export default CustomTestimonial
